<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Órdenes de Pago</strong>
          </div>
          <b-form>
            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols"
              description="Filtro por fecha contable del pago"
              horizontal>
              <b-form-input 
                id="fechaDesde" 
                v-model="fechaDesde" 
                :state="fechaDesdeValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaDesdeFeedback">
                {{ fechaDesdeInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols"
              description="Filtro por fecha contable del pago"
              horizontal>
              <b-form-input 
                id="fechaHasta" 
                v-model="fechaHasta" 
                :state="fechaHastaValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaHastaFeedback">
                {{ fechaHastaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <!-- <b-form-group
              label="Proveedor"
              label-for="proveedor"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarProveedor">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !proveedor,
                                  'fa fa-remove': proveedor  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="proveedor"
                  :value="proveedorNombre"
                  readonly
                  type="text"
                  :state="proveedorValido"/>
                <b-form-invalid-feedback id="proveedorFeedback">
                  {{ proveedorInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-input-group>
            </b-form-group> -->
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchProveedorModal"
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-proveedor
        :incluirInactivos="true"
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchProveedor from '../proveedores/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment';

export default {
  name: 'ABM',
  components: {
    appSearchProveedor: SearchProveedor,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      fechaDesdeValida: null,
      fechaDesdeInvalidaMsj: '',
      fechaHastaValida: null,
      fechaHastaInvalidaMsj: '',
      proveedorValido: null,
      proveedorInvalidoMsj: '',

      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
      proveedor: null,

      labelCols: 1,
    }
  },
  computed: {
    proveedorNombre() {
      return this.proveedor? this.proveedor.nombre.trim() : '';
    },
  },
  created() {
    
  },  
  methods: {
    validate() {
    },
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let proveedorId = 0;
      if (this.proveedor) {
        proveedorId = this.proveedor.id;
      }

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        proveedorId
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('pagos/getRptPagos', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptPagos = this.$store.getters['pagos/rptPagos'];

            if (rptPagos) {
              if (rptPagos.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              let title= 'Reporte de Pagos';
              let fileName = 'reporte-pagos';
              let format = [
                { titulo: 'Nro.Orden', nombre: 'numeroPago', formato: '' },
                // { titulo: 'Nro.Orden', nombre: 'pagoId', formato: '' },
                { titulo: 'Fecha Contable', nombre: 'fechaPago', formato: 'fecha' },
                { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
                { titulo: 'CUIT', nombre: 'proveedorDocumentoNumero', formato: '' },
                { titulo: 'Tipo Documento', nombre: 'documentoTipo', formato: '' },
                { titulo: 'Nro. Documento', nombre: 'documentoNumero', formato: '' },
                { titulo: 'Fecha Emisión', nombre: 'fechaEmisionDocumento', formato: 'fecha' },
                { titulo: 'Fecha Documento', nombre: 'fechaPagoDocumento', formato: 'fecha' },
                { titulo: 'Importe', nombre: 'importe', formato: '' },
                { titulo: 'Comprobantes', nombre: 'comprobantes', formato: '' },
              ];

              this.exportXLS(title, fileName, rptPagos, format);

            } else {
              this.showErrorMsj('No hay datos para exportar.')
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    goBack() {

    },
    seleccionarProveedor() {
      if (this.proveedor) {
        this.proveedor = null;
      } else {
        this.$refs.searchProveedorModal.show();
      }
    },
    proveedorSeleccionado(item) {
      this.proveedor = item;
      this.$refs.searchProveedorModal.hide();
    },
  },
}
</script>

<style>
</style>
